/* NAAMANE UI: statusbalk-kleur, modelfoto's in de winkelwagen, looks met wazige achtergrond, cart-pagina, productpagina met foto links (mobiel en tablet). */
(() => {
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;
  const ME = document.currentScript && document.currentScript.src;

  /* 0. 10%-popup: eerder weggeklikt? Eenmalig opnieuw tonen (nieuwe versie) */
  try {
    if (!localStorage.getItem('nm-ins-reset-2')) {
      localStorage.removeItem('nm-insider-closed');
      localStorage.setItem('nm-ins-reset-2', '1');
    }
  } catch (e) {}

  /* 1. Statusbalk bovenin (iPhone) donker zolang de banner bovenaan in beeld is */
  const meta = document.querySelector('meta[name="theme-color"]');
  const hero = document.querySelector('.nm-hero');
  if (meta && hero) {
    const light = meta.getAttribute('content');
    let dark = null;
    let tick = false;
    const set = () => {
      tick = false;
      const d = hero.getBoundingClientRect().bottom > 80;
      if (d === dark) return;
      dark = d;
      meta.setAttribute('content', d ? '#0b0b0b' : light);
      document.documentElement.classList.toggle('nm-top-dark', d);
    };
    set();
    window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(set); } }, { passive: true });
  }

  /* 2. Winkelwagen: modelfoto in plaats van de oude productfoto */
  const modelCache = {};
  const getModel = (handle) => {
    if (!modelCache[handle]) {
      let cached = null;
      try { cached = JSON.parse(sessionStorage.getItem('nm-model-' + handle) || 'null'); } catch (e) {}
      modelCache[handle] = cached ? Promise.resolve(cached) : fetch('/products/' + handle + '?section_id=nm-model-image')
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const m = html.match(/data-nm-src="([^"]+)"[^>]*data-nm-srcset="([^"]+)"/);
          const val = m ? { src: m[1].replace(/&amp;/g, '&'), srcset: m[2].replace(/&amp;/g, '&') } : {};
          try { sessionStorage.setItem('nm-model-' + handle, JSON.stringify(val)); } catch (e) {}
          return val;
        }).catch(() => ({}));
    }
    return modelCache[handle];
  };
  const swapCartImages = () => {
    document.querySelectorAll('.cart-items__media-container').forEach((a) => {
      const img = a.querySelector('img');
      const m = (a.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
      if (!img || !m || img.dataset.nmModel === m[1]) return;
      img.dataset.nmModel = m[1];
      getModel(m[1]).then((v) => {
        if (v && v.src) { img.src = v.src; img.srcset = v.srcset; img.sizes = '100px'; }
        if (typeof cartPageBg === 'function') setTimeout(cartPageBg, 50);
      });
    });
  };
  swapCartImages();
  let swapT;

  /* 3. Shop the look: elke kaart krijgt de kleur van zijn outfit */
  const tintLook = (card) => {
    if (card.dataset.nmTint) return;
    const src = card.querySelector('.nm-look__img');
    if (!src) return;
    card.dataset.nmTint = '1';
    const url = (src.currentSrc || src.src).replace(/([?&])width=\d+/, '$1width=80');
    const im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = () => {
      try {
        const c = document.createElement('canvas');
        const w = (c.width = 40);
        const h = (c.height = Math.round((40 * im.naturalHeight) / im.naturalWidth) || 50);
        const ctx = c.getContext('2d');
        ctx.drawImage(im, 0, 0, w, h);
        const d = ctx.getImageData(Math.round(w * 0.3), Math.round(h * 0.3), Math.round(w * 0.4), Math.round(h * 0.45)).data;
        let r = 0, g = 0, b = 0, n = 0;
        for (let i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
        r /= n; g /= n; b /= n;
        const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
        if (lum > 0.62) { card.classList.add('is-light'); r += (255 - r) * 0.15; g += (255 - g) * 0.15; b += (255 - b) * 0.15; }
        else { const k = lum < 0.25 ? 0.85 : 0.6; r *= k; g *= k; b *= k; }
        card.style.setProperty('--look-rgb', Math.round(r) + ' ' + Math.round(g) + ' ' + Math.round(b));
      } catch (e) { /* kleur is extra */ }
    };
    im.src = url;
  };
  const tintAll = () => document.querySelectorAll('.nm-look').forEach((card) => {
    const img = card.querySelector('.nm-look__img');
    if (!img) return;
    if (img.complete && img.naturalWidth) tintLook(card); else img.addEventListener('load', () => tintLook(card), { once: true });
  });
  /* 3b. Extra looks (Rugby Club, Rain Ready) uit de verborgen tweede sectie achteraan in de rij */
  const mainLooks = document.querySelector('#nm-cat-look .nm-looks__track');
  if (mainLooks) document.querySelectorAll('#nm-cat-look2 .nm-looks__card').forEach((c) => mainLooks.append(c));
  const looksBox = document.querySelector('.nm-looks');
  if (looksBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e], o) => { if (e.isIntersecting) { tintAll(); o.disconnect(); } }, { rootMargin: '600px' }).observe(looksBox);
  } else if (looksBox) tintAll();

  /* 4. Shop the look: achtergrond = wazige foto van de look die in beeld staat, actieve kaart groot */
  const bgSrc = (img, w) => {
    const s = img && (img.currentSrc || img.src);
    return s ? s.replace(/([?&])width=\d+/, '$1width=' + w) : '';
  };
  if (looksBox) {
    const track = looksBox.querySelector('.nm-looks__track');
    const cards = track ? [...track.querySelectorAll('.nm-looks__card')] : [];
    if (track && cards.length) {
      const bg = document.createElement('div');
      bg.className = 'nm-looks__bg';
      bg.setAttribute('aria-hidden', 'true');
      const layers = [new Image(), new Image()];
      layers.forEach((l) => { l.alt = ''; l.decoding = 'async'; bg.append(l); });
      looksBox.prepend(bg);
      let front = 0;
      let current = null;
      const show = (card) => {
        if (card === current) return;
        current = card;
        cards.forEach((c) => c.classList.toggle('is-active', c === card));
        const img = card.querySelector('.nm-look__img');
        if (img && !img.complete) img.loading = 'eager';
        const src = bgSrc(img, 400);
        if (!src) return;
        const next = layers[1 - front];
        next.onload = () => { next.classList.add('is-on'); layers[front].classList.remove('is-on'); front = 1 - front; };
        next.src = src;
        tintLook(card.querySelector('.nm-look') || card);
      };
      const pickCard = () => {
        const tr = track.getBoundingClientRect();
        const mid = tr.left + Math.min(tr.width, window.innerWidth) * (mobile() ? 0.5 : 0.3);
        let best = cards[0];
        let bd = Infinity;
        cards.forEach((c) => {
          const r = c.getBoundingClientRect();
          const d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bd) { bd = d; best = c; }
        });
        show(best);
      };
      let lt;
      track.addEventListener('scroll', () => { clearTimeout(lt); lt = setTimeout(pickCard, 70); }, { passive: true });
      window.addEventListener('resize', pickCard, { passive: true });
      new IntersectionObserver(([e], o) => { if (e.isIntersecting) { pickCard(); o.disconnect(); } }, { rootMargin: '400px' }).observe(looksBox);
    }
  }

  /* 5. Shop the look: tekst */
  document.querySelectorAll('.nm-looks__deal').forEach((d) => {
    const pct = (d.textContent.match(/\d+%/) || ['5%'])[0];
    d.innerHTML = 'Shop the look en krijg <strong>' + pct + ' extra korting</strong>.';
  });

  /* 6. Cart-pagina: achtergrond = wazige foto van je eerste item */
  const cartPageBg = () => {
    const page = document.querySelector('.cart-items-component:not([data-drawer]) .cart-page');
    if (!page) return;
    const main = page.closest('main') || document.body;
    let bg = main.querySelector(':scope > .nm-cart-bg');
    if (!bg) {
      bg = document.createElement('div');
      bg.className = 'nm-cart-bg';
      bg.setAttribute('aria-hidden', 'true');
      bg.append(new Image());
      main.prepend(bg);
    }
    const first = page.querySelector('.cart-items__media-image');
    const src = bgSrc(first, 400);
    const im = bg.querySelector('img');
    if (src && im.dataset.src !== src) {
      im.dataset.src = src;
      im.classList.remove('is-on');
      im.onload = () => im.classList.add('is-on');
      im.src = src;
    }
  };
  cartPageBg();
  new MutationObserver(() => { clearTimeout(swapT); swapT = setTimeout(() => { swapCartImages(); cartPageBg(); }, 80); })
    .observe(document.body, { childList: true, subtree: true });

  /* 9. Mix van sweater en T-shirt: ook in de rij T-shirts op de homepage */
  const tTrack = document.querySelector('#nm-cat-k4 .nm-stack__track');
  if (tTrack) ['rugby-polo-sweater-naamane', 'grey-beige-double-sleeve-sweater-shirt-naamane'].forEach((h) => {
    if (tTrack.querySelector('a[href*="/products/' + h + '"]')) return;
    const a = document.querySelector('.nm-stack__item a[href*="/products/' + h + '"]');
    const li = a && a.closest('.nm-stack__item');
    if (li) tTrack.prepend(li.cloneNode(true));
  });

  /* 10. Maatkeuze: alleen de maat tonen, niet een vaste kleur erachter (bijv. "S / Black" wordt "S") */
  const cleanOpts = () => document.querySelectorAll('.nm-look__size option, .nm-cu__sizes option, .nm-up__sizes option, .nm-cu__sizes button, .nm-up__sizes button').forEach((o) => {
    if (o.children.length) return;
    const t = o.textContent;
    const n = t.replace(/^(\S+)\s\/\s[^(]+?(\s\(|$)/, '$1$2');
    if (n !== t) o.textContent = n;
  });
  cleanOpts();
  new MutationObserver(() => { clearTimeout(cleanOpts.t); cleanOpts.t = setTimeout(cleanOpts, 120); }).observe(document.body, { childList: true, subtree: true });

  /* 8. Homepage-kaarten: wazige foto achter naam en prijs; label naast de prijs, bij sale als percentage */
  document.querySelectorAll('.nm-stack .nm-card').forEach((c) => {
    const i = c.querySelector('.nm-card__img');
    const src = bgSrc(i, 300);
    if (src) c.style.setProperty('--nm-card-bg', 'url("' + src + '")');
    const badge = c.querySelector('.nm-card__media .nm-card__badge');
    const price = c.querySelector('.nm-card__price');
    if (!badge || !price) return;
    const was = price.querySelector('s');
    if (was && /sale/i.test(badge.textContent)) {
      const num = (t) => parseFloat(t.replace(/[^\d,]/g, '').replace(',', '.'));
      const a = num(was.textContent);
      const b = num(price.textContent.replace(was.textContent, ''));
      if (a > b) badge.textContent = '-' + Math.round((1 - b / a) * 100) + '%';
    }
    price.append(badge);
  });

  /* 7. Productpagina: info ingeklapt; op mobiel en tablet (foto's boven de info) bij scrollen links de foto's, info rechts. */
  const initPdp = () => {
    document.querySelectorAll('.product-information accordion-custom').forEach((a) => { a.removeAttribute('open-by-default-on-mobile'); a.removeAttribute('open-by-default-on-desktop'); });
    document.querySelectorAll('.product-information accordion-custom details[open]').forEach((d) => { d.open = false; });
    const pd = document.querySelector('.product-information .product-details');
    const gal = document.querySelector('.product-information media-gallery');
    if (!pd || !gal || pd.dataset.nmPdpSplit) return;
    pd.dataset.nmPdpSplit = '1';
    if (ME && !document.querySelector('link[data-nm-pdp-tablet]')) {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = ME.replace('naamane-ui.js', 'naamane-pdp-tablet.css');
      l.dataset.nmPdpTablet = '1';
      document.head.append(l);
    }
    const splitOk = () => mobile() || (window.matchMedia('(max-width: 1199px)').matches && gal.getBoundingClientRect().width > window.innerWidth * 0.8);
    const strip = document.createElement('div');
    strip.className = 'nm-pdp-thumb nm-pdp-strip';
    const galleryImgs = () => [...gal.querySelectorAll('slideshow-slide img, .product-media img')].filter((i, k, a) => a.findIndex((x) => (x.getAttribute('src') || '').split('?')[0] === (i.getAttribute('src') || '').split('?')[0]) === k);
    const fill = () => {
      const list = galleryImgs().slice(0, 8);
      if (!list.length || strip.childElementCount === list.length) return;
      strip.replaceChildren(...list.map((el, k) => {
        const im = new Image();
        im.className = 'nm-pdp-strip__img';
        im.decoding = 'async';
        im.loading = k < 2 ? 'eager' : 'lazy';
        im.src = (el.getAttribute('src') || el.currentSrc).replace(/([?&])width=\d+/, '$1width=600');
        im.alt = el.alt || '';
        im.dataset.k = k;
        return im;
      }));
    };
    const ensure = () => { if (!strip.isConnected || strip.parentElement !== pd) pd.prepend(strip); };
    fill();
    ensure();
    new MutationObserver(ensure).observe(pd, { childList: true });
    const setSplit = (on) => {
      if (!splitOk()) on = false;
      if (pd.classList.contains('nm-pdp-split') === on) return;
      const items = [...pd.querySelectorAll('.group-block-content > *')];
      const anchor = items.find((e) => e.getBoundingClientRect().bottom > 90 && e.getBoundingClientRect().height > 0);
      const before = anchor ? anchor.getBoundingClientRect().top : 0;
      if (on) fill();
      pd.classList.toggle('nm-pdp-split', on);
      if (anchor) window.scrollBy(0, anchor.getBoundingClientRect().top - before);
    };
    new IntersectionObserver(([e]) => setSplit(!e.isIntersecting && e.boundingClientRect.top < 0), { rootMargin: '-45% 0px 0px 0px' }).observe(gal);
    strip.addEventListener('click', (e) => {
      const im = e.target.closest('.nm-pdp-strip__img');
      if (!im) return;
      const k = +im.dataset.k;
      const slides = gal.querySelector('slideshow-slides');
      const slide = gal.querySelectorAll('slideshow-slide')[k];
      gal.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (slides && slide) setTimeout(() => slides.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }), 350);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp);
  else initPdp();
  document.addEventListener('shopify:section:load', initPdp);
})();